module.exports = __webpack_public_path__ + "img/PRCA2_B.f75d5896.png";